import { css } from '@compiled/react';
import { UnifiedProfileQuery } from 'graphql/__generated__/UnifiedProfileQuery.graphql';
import { GroupsSummaryWrapper } from '../groups/GroupsSummary';
import { useLazyLoadQuery } from 'react-relay';
import { usePathParam } from 'react-resource-router';
import AboutMe from './AboutMe';
import { UNIFIED_PROFILE_QUERY } from 'graphql/UnifiedProfileQuery';
import { token } from '@atlaskit/tokens';
import { useScreenType } from 'utils';
import { ErrorBoundary } from 'react-error-boundary';
import Fallback from 'components/common/fallback/Fallback';
import { logBoundaryError } from 'services/logger';
import { LoadingSidePanelSection } from 'components/common/suspense-fallbacks/LoadingSidePanelSection';
import { Suspense } from 'react';
import Events from '../../profile/side-panel/Events';

const SidePanel = () => {
  const [pathProfileId] = usePathParam('pathProfileId');
  const unifiedProfileData = useLazyLoadQuery<UnifiedProfileQuery>(
    UNIFIED_PROFILE_QUERY,
    { internalId: pathProfileId as string },
  );
  const screenType = useScreenType();

  return (
    <div css={containerStyles}>
      <ErrorBoundary FallbackComponent={Fallback} onError={logBoundaryError}>
        <Suspense fallback={<LoadingSidePanelSection />}>
          <AboutMe data={unifiedProfileData} />
        </Suspense>
      </ErrorBoundary>
      {screenType === 'desktop' ? (
        <>
          <GroupsSummaryWrapper
            internalId={pathProfileId as string}
            isMainPanel={false}
          />
          <Events />
        </>
      ) : null}
    </div>
  );
};

export default SidePanel;

const containerStyles = css({
  display: 'flex',
  flexDirection: 'column',
  '@media (min-width: 1280px)': {
    maxWidth: '355px',
    gap: token('space.600'),
  },
});
